import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const min = (min: number): ValidatorFn => {
  const key = 'min';

  return (control: AbstractControl): ValidationErrors | null => {
    const value: number = +control.value;

    if (!value) return null;

    if (value < min)
      return {
        [key]: { actualValue: value, requiredValue: min, min: true },
      };

    return null;
  };
};
